import { useQuery } from "@apollo/client"
import { GET_SUGGESTED_GROUPS_USER } from "../graphql/queries/getSuggestedGroupsUser"

export const useSuggestedGroupsUser = (userId: string, first?: number, skip?: number, search?: string) => {
  console.log("useSuggestedGroupsUser: userId: " + userId)
  const { data, error, loading, refetch } = useQuery(GET_SUGGESTED_GROUPS_USER, {
    variables: {
      userId: userId,
      first: first,
      skip: skip,
      search: search,
    },
  })
  console.log({ data, error, loading, refetch })
  return {
    suggestedGroupsUser: data?.suggestedGroupsUser,
    error,
    loading,
    refetch,
  }
}
